import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import CustomColumnMenu from "../../components/DataGridCustomColumnMenu";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
// import { NotificationAddSharp } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { format } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  api,
  useGetNotificationQuery,
  useChangeNotificationStatusMutation,
} from "../../state/api";
import { deleteNotificationAction } from "../../redux/actions/notificationAction";
// import axios from "axios";

const Notification = () => {
  const theme = useTheme();
  let { data, error, isLoading } = useGetNotificationQuery();
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeNotificationStatus] = useChangeNotificationStatusMutation();
  // const [fcmToken, setFcmToken] = useState("");

  const toggleReadStatus = async (notificationId, currentStatus) => {
    const nextStatus = currentStatus === "read" ? "unread" : "read";
    try {
      await changeNotificationStatus({
        notificationId,
        status: nextStatus,
      }).unwrap();
      toast.success(`Marked as ${nextStatus}`);
    } catch (error) {
      console.error("Error updating notification status", error);
      toast.error("Failed to update status");
    }
  };

  useEffect(() => {
    if (data && data.data) {
      setRowData(data.data);
    }
  }, [data]);

  const handleEdit = async (notificationId) => {
    try {
      navigate(`/notification/edit/${notificationId}`);
    } catch (error) {
      console.log("Error navigating to edit", error);
      toast.error("Error navigating to edit");
    }
  };

  const handleDelete = async (_id) => {
    try {
      const success = await dispatch(deleteNotificationAction(_id));
      if (success) {
        toast.success("Notification deleted successfully");
        dispatch(api.util.invalidateTags(["Notification"]));
      } else {
        toast.error("Failed to delete Notification");
      }
    } catch (error) {
      console.error("Error Deleting Notification", error);
    }
  };

  // const handleSendNotification = async () => {
  //   try {
  //     const response = await axios.post("/fcm/notification/send", { fcmToken });
  //     console.log("Notification sent:", response.data);
  //   } catch (error) {
  //     console.error("Error sending notification:", error);
  //   }
  // };

  const removeNotification = (_id) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(_id);
      }
    });
  };

  const navigateCreate = () => {
    navigate("/notification/create");
  };

  const columns = [
    {
      field: "title",
      headerName: "Title",
      flex: 0.5,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 0.5,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5, renderCell: (params) => (
        <span
          onClick={() => toggleReadStatus(params.row._id, params.value)}
          title="Click to toggle read/unread"
          style={{
            backgroundColor: params.value === 'read' ? 'green' : '#f5c518',
            color: params.value === 'read' ? 'white' : '#1a1a1a',
            padding: '5px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
          }}>
          {params.value === 'read' ? 'read' : 'unread'}
        </span>
      ),
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "updatedAt",
      headerName: "UpdatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      flex: 0.6,
      renderCell: (params) => (
        <div>
          <IconButton
            // variant="contained"
            color="info"
            onClick={() => handleEdit(params.row._id)}
          >
            <EditIcon size="large" />
          </IconButton>
          {/* <IconButton
            color="info"
            onClick={() => handleSendNotification(params.row._id)}
            onChange={(e) => setFcmToken(e.target.value)}
            label="FCM Token"
            value={fcmToken}
          >
            <NotificationAddSharp size="small" />
          </IconButton> */}
          <IconButton
            variant="contained"
            color="secondary"
            onClick={() => removeNotification(params.row._id)}
          >
            <DeleteIcon size="small" sx={{ color: "red" }} />
          </IconButton>
        </div>
      ),
    },
  ];
  return (
    <Box m="1.5rem 2.5rem">
      <ToastContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap="1rem"
      >
        <Header title="NOTIFICATION MANAGEMENT" />
        <Button
          variant="contained"
          endIcon={<AddCircleIcon />}
          onClick={navigateCreate}
        >
          Add notificaton
        </Button>
      </Box>

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.success,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={rowData || []}
          columns={columns}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 20, 50, 100]}
          components={{
            ColumnMenu: CustomColumnMenu,
          }}
        />
      </Box>
    </Box>
  );
};
export default Notification;
